import ProductPlaceholder from './productPlaceholder.component';

export default ProductPlaceholder;
